var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-5" },
    [
      _c(
        "div",
        { staticClass: "p-5 bg-white" },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.list,
                stripe: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "名称", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.type_name) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "音乐链接" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v("微信：" + _vm._s(scope.row.music_link)),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "支付宝：" +
                              _vm._s(scope.row.zfb_music_link || "--")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "蓝牙连接", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.support_buletooth == 1 ? "是" : "否"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              round: "",
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                _vm.editDialog = true
                                _vm.editForm = scope.row
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex justify-center" },
            [
              _c("pagination", {
                attrs: {
                  page: _vm.listQuery.page,
                  limit: _vm.listQuery.limit,
                  "page-count": _vm.listQuery.page_num,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.listQuery, "page", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.listQuery, "limit", $event)
                  },
                  pagination: _vm.getList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "编辑设备类型", visible: _vm.editDialog },
          on: {
            "update:visible": function ($event) {
              _vm.editDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "auto" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "类型名称：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.editForm.type_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "type_name", $$v)
                      },
                      expression: "editForm.type_name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "蓝牙连接：" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.editForm.support_buletooth,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "support_buletooth", $$v)
                      },
                      expression: "editForm.support_buletooth",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "支付宝音频链接：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.editForm.zfb_music_link,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "zfb_music_link", $$v)
                      },
                      expression: "editForm.zfb_music_link",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "微信音频文件：" } },
                [
                  _c("upload", {
                    attrs: { uploadText: "上传音乐" },
                    model: {
                      value: _vm.editForm.music_link,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "music_link", $$v)
                      },
                      expression: "editForm.music_link",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.editForm.music_link))]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.editID()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }